<script setup lang="ts">
import { displayNameInitials } from '@schwrz/shared';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    firstName: string;
    lastName: string;
    avatarUrl?: string | null;
    size?: 'xs' | 'sm' | 'md' | 'lg';
    title?: string;
    /** When true, omit role/label — for decorative use inside a parent group. */
    decorative?: boolean;
  }>(),
  {
    avatarUrl: null,
    size: 'md',
    title: undefined,
    decorative: false,
  },
);

const initials = computed(() =>
  displayNameInitials({ firstName: props.firstName, lastName: props.lastName }),
);

const label = computed(
  () => props.title ?? (`${props.firstName} ${props.lastName}`.trim() || 'Профиль'),
);
</script>

<template>
  <span
    class="user-avatar"
    :class="`user-avatar--${size}`"
    :title="decorative ? undefined : label"
    :role="decorative ? undefined : 'img'"
    :aria-label="decorative ? undefined : label"
    :aria-hidden="decorative ? true : undefined"
  >
    <img
      v-if="avatarUrl"
      class="user-avatar__image"
      :src="avatarUrl"
      alt=""
    />
    <span
      v-else
      class="user-avatar__initials"
      aria-hidden="true"
    >{{ initials }}</span>
  </span>
</template>
